// src/hooks/useAdminRoles.ts
import { useCallback, useEffect, useState } from 'react';
import type { Role } from 'types';
import { getRoles } from 'services/rolesApi';

export interface UseAdminRolesResult {
  roles: Role[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

/** Загружает список ролей из `/roles/all`. */
export function useAdminRoles(): UseAdminRolesResult {
  const [roles, setRoles] = useState<Role[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  const refetch = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    getRoles()
      .then((list) => {
        if (cancelled) return;
        setRoles(list);
        setError(null);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e instanceof Error ? e.message : 'Ошибка загрузки ролей');
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [tick]);

  return { roles, isLoading, error, refetch };
}
